(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cr8-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Gallery carousel: arrows + thumbnail sync over the native scroll-snap track.
    var gallery = document.querySelector('[data-cr8-gallery]');
    if (gallery) {
      var track = gallery.querySelector('[data-cr8-gallery-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-cr8-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-cr8-gallery-thumb]'));
      var prev = gallery.querySelector('[data-cr8-gallery-prev]');
      var next = gallery.querySelector('[data-cr8-gallery-next]');

      var currentIndex = function () {
        return Math.round(track.scrollLeft / track.clientWidth);
      };

      var goTo = function (index) {
        var clamped = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
      };

      if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { goTo(i); });
      });

      var syncTimer = null;
      track.addEventListener('scroll', function () {
        if (syncTimer) window.clearTimeout(syncTimer);
        syncTimer = window.setTimeout(function () {
          var index = currentIndex();
          thumbs.forEach(function (thumb, i) {
            thumb.classList.toggle('is-selected', i === index);
          });
        }, 80);
      }, { passive: true });
    }

    var triggers = document.querySelectorAll('[data-cr8-zoom-trigger]');
    if (!triggers.length) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'cr8-zoom-dialog';
    dialog.innerHTML = '<button type="button" class="cr8-zoom-dialog__close" aria-label="Close image">&times;</button><img class="cr8-zoom-dialog__image" alt="">';
    document.body.appendChild(dialog);

    var img = dialog.querySelector('.cr8-zoom-dialog__image');
    dialog.querySelector('.cr8-zoom-dialog__close').addEventListener('click', function () {
      dialog.close();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        img.src = trigger.getAttribute('href');
        img.alt = trigger.getAttribute('aria-label') || '';
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr8-sticky-purchase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-cr8-sticky-purchase]');
    if (!bar) return;

    var threshold = 480;
    var ticking = false;

    function update() {
      var visible = window.scrollY > threshold;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
